module.exports = {
    input: require('../directives/input'),
    select: require('../directives/select')
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/mixins/directives.js